import React from 'react';
import { Instagram, MessageCircle } from 'lucide-react';
import { BRAND } from '../mock';

export default function Footer() {
  return (
    <footer className="bg-stone-950 text-stone-300 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-4">
            <img
              src="/images/leila-logo.jpg"
              alt="Leila Tesettür"
              className="h-16 w-16 rounded-full object-cover ring-1 ring-stone-700"
            />
            <div>
              <div className="font-serif text-3xl text-[#f7f2ec]">Leila</div>
              <div className="text-[10px] tracking-[0.3em] uppercase text-stone-500 mt-1">Tesettür</div>
            </div>
          </div>
          <p className="mt-5 max-w-md text-[14px] leading-relaxed text-stone-400">
            Zarafetin yeni adresi. Sade, zamansız ve özenle üretilmiş tesettür parçalarıyla
            duruşunuzu tamamlıyoruz.
          </p>
        </div>

        <div>
          <h4 className="text-[10px] tracking-[0.28em] uppercase text-stone-500">Keşfet</h4>
          <ul className="mt-4 space-y-2 text-[14px]">
            <li><a href="#koleksiyon" className="hover:text-white transition-colors">Koleksiyon</a></li>
            <li><a href="#hikayemiz" className="hover:text-white transition-colors">Hikâyemiz</a></li>
            <li><a href="#sss" className="hover:text-white transition-colors">SSS</a></li>
            <li><a href="#iletisim" className="hover:text-white transition-colors">İletişim</a></li>
          </ul>
        </div>

        <div>
          <h4 className="text-[10px] tracking-[0.28em] uppercase text-stone-500">İletişim</h4>
          <ul className="mt-4 space-y-3 text-[14px]">
            <li>
              <a href={BRAND.whatsappUrl} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 hover:text-white transition-colors">
                <MessageCircle className="h-4 w-4" /> +90 535 064 00 41
              </a>
            </li>
            <li>
              <a href={BRAND.instagramUrl} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 hover:text-white transition-colors">
                <Instagram className="h-4 w-4" /> @{BRAND.instagram}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-10 mt-14 pt-6 border-t border-stone-800 flex flex-wrap items-center justify-between gap-3">
        <p className="text-[12px] text-stone-500">
          © {new Date().getFullYear()} Leila Tesettür. Tüm hakları saklıdır.
        </p>
        <p className="text-[12px] text-stone-500">Zarafetin yeni adresi · Yeni Sezon 2026</p>
      </div>
    </footer>
  );
}
